import { render, staticRenderFns } from "./KeyValueCard.vue?vue&type=template&id=09f34969&scoped=true"
import script from "./KeyValueCard.vue?vue&type=script&lang=js"
export * from "./KeyValueCard.vue?vue&type=script&lang=js"
import style0 from "./KeyValueCard.vue?vue&type=style&index=0&id=09f34969&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f34969",
  null
  
)

export default component.exports